import axiosInstance from '../axiosInstance'

export const makeToOrderService = {
  fetch: async (skip = 0, limit = 15, clientId) => {
    try {
      let response = await axiosInstance.get(
        `make-to-order?$limit=${limit}&$skip=${skip}&client_id=${clientId}&$populate=supplier&$populate=client_id&$populate=purchase_order&$sort[createdAt]=-1`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  create: async (obj) => {
    try {
      let response = await axiosInstance.post("create-m2o-order", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (id, obj) => {
    try {
      const response = await axiosInstance.patch(`make-to-order/${id}`, obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`make-to-order/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchM2OAsnTrail: async (id) => {
    try {
      const response = await axiosInstance.get(`/fetch-m2o-asn-trail/${id}`);
      return response.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  fetchById: async (id) => {
    try {
      const response = await axiosInstance.get(
        `make-to-order/${id}?$populate=supplier&$populate=client_id&$populate=purchase_order&$sort[createdAt]=-1`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchASNBySku: async (sku, skip = 0, limit = 15, search) => {
    try {
      let apiQuery = `make-to-order?$limit=${limit}&$skip=${skip}&sku_list.sku=${sku}&$sort[createdAt]=-1`;
      if (search) apiQuery += `&asn_no[$search]=${search}`;
      const response = await axiosInstance.get(apiQuery);
      return response.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
};
